import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'

/**
 * Lazy load views for better code splitting
 * Only loads component when route is accessed
 */
const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/HomeView.vue'),
    meta: {
      title: 'Kogeneesti - Learn Languages'
    }
  },
  {
    path: '/dictionary/:id',
    name: 'Dictionary',
    component: () => import('@/views/DictionaryView.vue'),
    props: true,
    meta: {
      title: 'Dictionary'
    }
  },
  {
    path: '/quiz/:id',
    name: 'DictionaryQuiz',
    component: () => import('@/views/QuizView.vue'),
    props: true,
    meta: {
      title: 'Practice Quiz'
    }
  },
  {
    path: '/quizzes',
    name: 'Quizzes',
    component: () => import('@/views/QuizzesView.vue'),
    meta: {
      title: 'Quizzes'
    }
  },
  {
    path: '/quizzes/:id',
    name: 'QuizDetail',
    component: () => import('@/views/QuizDetailView.vue'),
    props: true,
    meta: {
      title: 'Quiz Details'
    }
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/'
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

/**
 * Update document title based on route meta
 */
router.afterEach((to) => {
  document.title = (to.meta.title as string) || 'Kogeneesti'
})

export default router
